import store from '../store';
import i18n from '../i18n';
import { cosStsRegion } from "../util/APIUtils";


let g_API_BASE_URL = '';
let g_UI_BASE_URL = '';

if (process.env.NODE_ENV === 'development') {
  let devHost = process.env.VUE_APP_DEV_HOST;
  if (process.env.MODE_TYPE === '1') {
    devHost = process.env.VUE_APP_t_DEV_HOST;
  }
  g_API_BASE_URL = process.env.VUE_APP_g_UI_BASE_URL;
  g_UI_BASE_URL = 'http://' + devHost + ':3000';
} else {
  g_API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
  g_UI_BASE_URL = process.env.VUE_APP_BASE_URL;
}

export const API_BASE_URL = g_API_BASE_URL;
export const UI_BASE_URL = g_API_BASE_URL;


export const OAUTH2_REDIRECT_URI = '/oauth2/redirect';

export const FACEBOOK_AUTH_URL = API_BASE_URL.replace("/api", "") + '/api/facebook/login';
export const TWITTer_AUTH_URL = API_BASE_URL.replace("/api", "") + '/api/twitter/login';
export const GOOGLE_AUTH_URL = API_BASE_URL.replace("/api", "") + '/api/google/login';


export function notEmpty(value) {
  return value !== 'undefined' && value !== undefined && value !== null && value !== '';
}

export function empty(value) {
  return value === 'undefined' || value === undefined || value === null || value === '';
}
export function getUrlParameter(search, name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');

  let results = regex.exec(search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function matchGameDetail() {
  //return /\/games\/[^A-Za-z0-9\-_]{3,}$/gi.test(window.location.href)
  if (window.location.href.includes('/games/earlyaccess') ||
    window.location.href.includes('/games/label') ||
    window.location.href.includes('/games/questionnaire')
  ) return false;
  if (window.location.href.includes('/refresh')) return true;
  return !!/\/games\/[^ ]{3,}$/.test(window.location.href);
}

export function getCosRegion() {
  return new Promise((resolve, reject) => {
    cosStsRegion().then(response => {
      let cosRegionStr = JSON.stringify(response.data);
      store.dispatch('setCosRegion', cosRegionStr);
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  }).catch(error => {
    reject(error);
  });

}
export function removeURLParameter(url, parameter) {
  //prefer to use l.search if you have a location/link object
  let urlparts = url.split('?');
  if (urlparts.length >= 2) {

    let prefix = encodeURIComponent(parameter) + '=';
    let pars = urlparts[1].split(/[&;]/g);

    //reverse iteration as may be destructive
    for (let i = pars.length; i-- > 0;) {
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }
    return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

let imgDomain = 'https://cdn.cloudgame.qcloud.com';


export const ImgDomain = imgDomain;
export const NotFoundImg = imgDomain + '/public/grey-wallpaper-small.jpg';


export function randomString() {
  let str = "";
  let arr = ['a', 'b', 'c', 'd', 'e', 'f', 'g',
    'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y',
    'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q',
    'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  // 随机产生，i
  for (let i = 0; i < 10; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
}


// 全局正则表达式
//产品侧给到的规则是 ：密码 6-15可以包含特殊字符区分大小写 用户名最多15字符 可以包含特殊字符
export const REG = {
  email: /^([A-Za-z0-9_\-\.\u4e00-\u9fa5])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
  // name:/^[a-zA-Z]\w{0,14}$/,
  nameContainSpace: /^[^\s]*$/,
  // name:/^[\u3040-\u309F\u30A0-\u30FF\u4e00-\u9fa5\sa-zA-Z0-9]{0,15}$/,
  // name:/^[\s\S]{0,15}$/,                      //15位以内任意字符
  name: /^[\u3040-\u309F\u30A0-\u30FF\u4e00-\u9fa5a-zA-Z0-9\s]{1,30}$/,
  signature: /^[\u3040-\u309F\u30A0-\u30FF\u4e00-\u9fa5a-zA-Z0-9\s]{1,200}$/,
  // password:/^[\w+!@#$%^&*.]{6,18}$/,
  password: /^[^ ]{6,15}$/,            //6-15位不包含空格
  // password:/^[\d\D]{6,18}$/,
  // password:   /^[A-Za-z\d]{6,18}$/,   //6-18位以内不能有特殊字符
  confirmPassword: /^[^ ]{6,15}$/
  // confirmPassword:/^[\d\D]{6,18}$/
};

let errorMsgMap = {
  'email-format': i18n.t('SignupForm.emailFormat'),
  'name-format': i18n.t('SignupForm.usernameInvalid'),
  'signature-format': i18n.t('SignupForm.signatureInvalid'),
  'password-format': i18n.t('SignupForm.pwdInvalid'),
  'confirmPassword-format': i18n.t('SignupForm.pwdInvalid'),
  'password-match': i18n.t('SignupForm.pwdNotMatch'),
  'country-empty': i18n.t('SignupForm.selectCountry'),
  'privacy-unselected': i18n.t('SignupForm.emailFormat'),
  'name-obtainSpace': i18n.t('SignupForm.obtainSpace'),
};

// 表单提交前验证
export const validFormMobile = (form) => {
  let keyArr = ['email', 'name', 'password', 'confirmPassword', 'signature'];
  let alarmMsg = [];
  keyArr.forEach(key => {
    if (form.hasOwnProperty(key)) {
      if (!notEmpty(form[key])) {
        alarmMsg.push(errorMsgMap[key + '-format']);
      }
      else if (!REG[key].test(form[key]))
        alarmMsg.push(errorMsgMap[key + '-format']);
    }
  });
  if (form.hasOwnProperty('name')) {
    if (!REG.nameContainSpace.test(form['name'])) alarmMsg.push(errorMsgMap['name-obtainSpace']);
  }
  if (form.hasOwnProperty('password') && form.hasOwnProperty('confirmPassword')) {
    if (form['password'] !== form['confirmPassword']) alarmMsg.push(errorMsgMap['password-match']);
  }

  if (form.hasOwnProperty('country')) {
    if (!notEmpty(form['country'])) alarmMsg.push(errorMsgMap['country-empty']);
  }

  if (form.hasOwnProperty('checkboxPrivacy')) {
    if (form['checkboxPrivacy'] === false) alarmMsg.push('Privacy Policy of Use is unselected');
  }

  if (form.hasOwnProperty('checkboxTerm')) {
    if (form['checkboxTerm'] === false) alarmMsg.push('Terms of Serivce is unselected');
  }
  return alarmMsg;
};

// 表单提交前验证
export const validForm = (form) => {
  console.log(form);
  let keyArr = ['email', 'name', 'password', 'confirmPassword', 'signature'];
  let alarmMsg = [];
  keyArr.forEach(key => {
    if (form.hasOwnProperty(key)) {
      if (!notEmpty(form[key])) {
        alarmMsg.push(errorMsgMap[key + '-format']);
      }
      else if (!REG[key].test(form[key]))
        alarmMsg.push(errorMsgMap[key + '-format']);
    }
  });
  if (form.hasOwnProperty('password') && form.hasOwnProperty('confirmPassword')) {
    if (form['password'] !== form['confirmPassword']) alarmMsg.push(errorMsgMap['password-match']);
  }

  if (form.hasOwnProperty('country')) {
    if (!notEmpty(form['country'])) alarmMsg.push(errorMsgMap['country-empty']);
  }

  if (form.hasOwnProperty('checkboxPrivacy')) {
    if (form['checkboxPrivacy'] === 'not_accepted') alarmMsg.push('privacy-unselected');
    if (form['checkboxPrivacy'] === 'not_accepted') alarmMsg.push('Privacy Policy is unselected');
  }

  if (form.hasOwnProperty('checkboxTerm')) {
    if (form['checkboxTerm'] === 'not_accepted') alarmMsg.push('Terms of Use is unselected');
  }
  return alarmMsg;
};


export const validDate = (y, m, d) => {
  let valid = false;
  if (m.length < 2 || m < 10)
    m = '0' + m;
  if (d.length < 2 || d < 10)
    d = '0' + d;

  if (y && m && d) {
    let dateStr = y + '-' + m + '-' + d;
    let date = new Date(dateStr);
    if (date) {
      if (date.getFullYear() == y && (date.getMonth() + 1) == m && date.getDate() == d) {
        return true;
      }
    }
  }
  return valid;
};
console.log(validDate(2014, 2, 1));


// 单个字段提交前验证
export const validKey = (key, value) => {
  if (!notEmpty(value) || !REG[key].test(value)) {
    return errorMsgMap[key + '-format'];
  }
  return null;
};

// 欧盟年龄小于16岁
export const EuCountries = [
  'lu', 'mt', 'nl', 'no', 'no', 'pl', "pt", "ro", "sk", "si",
  "es", "se", "gb", "es", "at", "be", "bg", "cy", "cz", "dk",
  "ee", "fi", "fr", "de", "gr", "hu", "is", "ie", "it", "lv",
  "li", "lt", "ch"
];
export const CountryAgeLimit = {
  'in': 18, 'id': 21, 'jp': 20, 'my': 18, 'ph': 18, 'kr': 14, 'sg': 18, 'th': 20, 'tr': 18,
  'vn': 16, 'us': 16
};
// 其余国家小于13岁

/**
 * 主站当前支持的语言种类
 */
export const LanguageSupportedList = ['en', 'ja', 'ko', 'zh-tw'];
/**
 * 遇到未支持语言时采用的兜底语言
 */
export const DefaultLanguage = 'en';
/**
 * 主站支持韩语的页面: 云游戏 首页 登录页 注册页 设置页面 邮箱验证相关页面 协议相关页面
 */
export const KoreanPages = ['cloudGame', 'login', 'signup', 'account', 'verifyActivateEmail', 'changeEmail', 'privacyPolicy', 'termOfUse', 'refresh'];

let imgServerHost = "";
switch (window.location.host) {
  case "cloudgame-test.gameexp.com":
    imgServerHost = "https://ct-global-dev-1300343054.cos.ap-singapore.myqcloud.com";
    break;
  case "cloudgame.qcloud.com":
    imgServerHost = "https://cdn.cloudgame.qcloud.com";
    break;

  default:
    imgServerHost = "https://ct-global-dev-1300343054.cos.ap-singapore.myqcloud.com";
    break;
}
export const ImgServerHost = imgServerHost;